import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import { Context as IntlContext } from "context/Intl";
import { MegaMenuCategoryColumn } from "./mega-menu";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "components/ui/accordion";
import { Button } from "components/ui/button";
import { cn } from "lib/utils";
import { ROUTES } from "routes";

import { SERVICES_MENU_PANEL } from "./config";
import { useServicesMenuLabels } from "./useServicesMenuLabels";

interface ServicesMenuMobileProps {
    label: string;
    isActive: boolean;
    onClose: () => void;
}

export const ServicesMenuMobile: React.FC<ServicesMenuMobileProps> = ({ label, isActive, onClose }) => {
    const intl = useContext(IntlContext);
    const { categories } = useServicesMenuLabels();

    return (
        <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="services" className="border-none">
                <AccordionTrigger
                    className={cn(
                        "rounded-md py-3 pl-3 pr-3 text-sm font-bold uppercase tracking-wide transition-colors hover:no-underline [&>svg]:ml-auto [&>svg]:shrink-0",
                        isActive ? "bg-primary/10 text-primary" : "text-foreground hover:bg-accent",
                    )}
                >
                    {label}
                </AccordionTrigger>
                <AccordionContent className="pb-0">
                    <div className="space-y-3 px-1 py-2">
                        <Button variant="menuCta" asChild>
                            <Link to={ROUTES.PROVIDERS} onClick={onClose}>
                                {intl.formatMessage(SERVICES_MENU_PANEL.viewAllKey)}
                                <ChevronRight className="h-4 w-4" aria-hidden />
                            </Link>
                        </Button>

                        {categories.map((category) => (
                            <MegaMenuCategoryColumn
                                key={category.id}
                                category={category}
                                onNavigate={onClose}
                                layout="mobile"
                            />
                        ))}
                    </div>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};
